// Per-country config loader. Imports all 6 JSON files statically
// (webpack/CRA needs static imports to bundle them) and resolves
// the active config at module load time using REACT_APP_PORTAL_COUNTRY.
//
// Falls back to in.json for any unrecognized code.

import inJson from './countries/in.json';
import ukJson from './countries/uk.json';
import myJson from './countries/my.json';
import sgJson from './countries/sg.json';
import jpJson from './countries/jp.json';
import phJson from './countries/ph.json';

const ALL = {
  in: inJson,
  uk: ukJson,
  my: myJson,
  sg: sgJson,
  jp: jpJson,
  ph: phJson,
} as const;

const code = (process.env.REACT_APP_PORTAL_COUNTRY || 'IN').toLowerCase() as keyof typeof ALL;

const country = ALL[code] ?? inJson;

export default country;
export type CountryConfig = typeof inJson & {
  profileCompletionPoints: number;
  referralMonthlyPoints: number;
  minRedemptionPoints: number;
  referralMonthlyMaxPoints: number;
  pointsLabel: string;
  supportedLanguages: string[];
  localizationColumn: string;
  localizationLabel: string;
  // BCP-47 locale: fallback ONLY for Utils/formatDate when the user's selected
  // language is missing. The active format locale is driven by language, not
  // country (Utils/formatDate.LANGUAGE_LOCALE).
  locale: string;
  // IANA timezone, country-driven. Used by Utils/formatDate.
  timezone: string;
};
